import styled from "styled-components";

export const CLPStyles = styled.div`
  ${(props) =>
    props.appointment &&
    `
    overflow: hidden;
    max-height: 100vh;
    `};
  .overlay-color {
    background: linear-gradient(
      to right,
      rgba(54, 181, 95, 0.8) 0%,
      rgba(58, 194, 211, 0.8) 100%
    );
  }
  .overlay-color-dark {
    background: rgba(0, 0, 0, 0.55);
  }

  .hiw-content {
    .cta-container {
      text-align: center;
      ${(props) => props.theme.media.lg} {
        text-align: right;
      }
    }
  }
  .hiw-content h2 {
    font-weight: 700;
    font-size: 2.35rem;
  }

  .title-bottom {
    font-weight: 700;
    font-size: 2.35rem;
  }

  .lp-cards-title {
    h2 {
      font-weight: 700;
    }
  }
`;
